/* unplugin-vue-components disabled */import { render } from "./CollectHome.vue?vue&type=template&id=d1850290&scoped=true"
import script from "./CollectHome.vue?vue&type=script&lang=js"
export * from "./CollectHome.vue?vue&type=script&lang=js"

import "./CollectHome.vue?vue&type=style&index=0&id=d1850290&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1850290"]])

export default __exports__